var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pl-0 pr-0 py-0"},[_c('span',{staticClass:"the-title text-h4"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }